var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: !0 });
function getNameInitial(name) {
  return name ? name.charAt(0) : "?";
}
__name(getNameInitial, "getNameInitial");
const blueColors = [
  "#4BB3D2",
  // 浅蓝
  "#69DCF7",
  // 天蓝
  "#7FE0F4",
  // 淡蓝
  "#0C6F8E",
  // 深蓝
  "#0F475C",
  // 暗蓝
  "#0087B3",
  // 湖蓝
  "#5CD6F7",
  // 亮蓝
  "#89E3F0",
  // 浅青
  "#7CD2ED",
  // 天青
  "#B4EFF5"
  // 淡青
], redColors = [
  "#F2959F",
  // 粉红
  "#F9444E",
  // 亮红
  "#E73845",
  // 红色
  "#D3393F",
  // 深红
  "#7F1D2D",
  // 暗红
  "#9F2D36",
  // 砖红
  "#F23D4A",
  // 鲜红
  "#F26672",
  // 玫红
  "#F78292",
  // 粉红
  "#FABFC8"
  // 淡粉
], greenColors = [
  "#4DB585",
  // 淡绿
  "#41AB7D",
  // 浅绿
  "#19A86E",
  // 绿色
  "#107E55",
  // 深绿
  "#0B472F",
  // 暗绿
  "#116647",
  // 墨绿
  "#1DB878",
  // 鲜绿
  "#4DE2A6",
  // 亮绿
  "#81E4B7",
  // 薄荷绿
  "#B1F1CF"
  // 嫩绿
], yellowColors = [
  "#EDA049",
  // 橙黄
  "#FAC651",
  // 明黄
  "#FFBB38",
  // 金黄
  "#BA793D",
  // 棕黄
  "#66431E",
  // 深棕
  "#9C642D",
  // 赭黄
  "#FFB72F",
  // 亮黄
  "#FFD146",
  // 鲜黄
  "#FFD882",
  // 浅黄
  "#FFEABF"
  // 淡黄
], allColors = [...blueColors, ...redColors, ...greenColors, ...yellowColors];
function getBgColor(name, nameInitial) {
  if (!name)
    return "#1F2937";
  const initial = nameInitial.toUpperCase();
  let hash = 0;
  return hash = initial.charCodeAt(0) + ((hash << 5) - hash), allColors[Math.abs(hash) % allColors.length];
}
__name(getBgColor, "getBgColor");
export {
  getBgColor,
  getNameInitial
};
//# sourceMappingURL=utils.js.map
